import type { EntityValue, Kind, Note } from './model';
import { newTable } from './model';

export const SEED_NOTE = 'fd577c8e-d3a3-43c6-a197-af65506818e2';
export const SEED_TASK = 'fe577c8e-d3a3-43c6-a197-af65506818e2';

export function initialRecords(): { id: string; kind: Kind; value: EntityValue }[] {
  const note: Note = {
    title: 'App payments · working notes',
    area: 'Projects',
    parentId: null,
    updatedAt: new Date().toISOString(),
    content: {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
          content: [
            {
              type: 'text',
              text: 'A place to leave the next small step. Edit this note, add a block, or capture an idea without leaving your work.',
            },
          ],
        },
        {
          type: 'heading',
          attrs: { level: 2 },
          content: [{ type: 'text', text: 'Where I left off' }],
        },
        {
          type: 'blockquote',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  type: 'text',
                  text: 'Account setup is ready. Next: create a sandbox tester, then run one test purchase.',
                },
              ],
            },
          ],
        },
        {
          type: 'heading',
          attrs: { level: 2 },
          content: [{ type: 'text', text: 'Useful command' }],
        },
        {
          type: 'codeBlock',
          attrs: { language: 'bash' },
          content: [
            {
              type: 'text',
              text: 'npm run test -- --watch\n# Copy preserves whitespace and literal characters.',
            },
          ],
        },
        {
          type: 'heading',
          attrs: { level: 2 },
          content: [{ type: 'text', text: 'A small checklist' }],
        },
        {
          type: 'taskList',
          content: [
            {
              type: 'taskItem',
              attrs: { checked: true },
              content: [
                {
                  type: 'paragraph',
                  content: [{ type: 'text', text: 'Check the app’s bundle ID' }],
                },
              ],
            },
            {
              type: 'taskItem',
              attrs: { checked: false },
              content: [
                {
                  type: 'paragraph',
                  content: [{ type: 'text', text: 'Create a sandbox test account' }],
                },
              ],
            },
          ],
        },
        { type: 'typedTable', attrs: { table: newTable() } },
        { type: 'paragraph' },
      ],
    },
  };

  return [
    { id: SEED_NOTE, kind: 'note', value: note },
    {
      id: SEED_TASK,
      kind: 'task',
      value: {
        title: 'Configure Apple sandbox purchases',
        noteId: SEED_NOTE,
        done: false,
        today: true,
        stoppingPoint: 'Create a sandbox tester, then run one test purchase.',
        steps: [
          { id: crypto.randomUUID(), text: 'Check the app’s bundle ID', done: true },
          { id: crypto.randomUUID(), text: 'Create a sandbox test account', done: false },
          { id: crypto.randomUUID(), text: 'Complete one test purchase', done: false },
        ],
      },
    },
    {
      id: 'fa577c8e-d3a3-43c6-a197-af65506818e2',
      kind: 'task',
      value: {
        title: 'Find the vacuum’s model number',
        noteId: null,
        done: false,
        today: true,
        steps: [],
        stoppingPoint: '',
      },
    },
    {
      id: 'fb577c8e-d3a3-43c6-a197-af65506818e2',
      kind: 'task',
      value: {
        title: 'Choose a gym for the first visit',
        noteId: null,
        done: false,
        today: true,
        steps: [],
        stoppingPoint: '',
      },
    },
  ];
}
